module.exports = __webpack_public_path__ + "static/media/fidweb-alpi-article_optimized.3cf9c34c.png";